export default {
    Menu: 'Menu',
    Add: 'Tilføj',
    Modify: 'Rediger',
    Delete: 'Slet',
    Scale: 'Tilpas størrelse',
    Color: 'Farve',
    Materials: 'Materialer',
    Mesh: 'Mesh',
    Size: 'Størrelse',
    Details: 'Detaljer',
    Quantity: 'Antal',
    AddToCart: 'Læg i kurv',
    AddToCartTitle: 'Læg i kurv',
    Cart: 'Kurv',
    Total: 'I alt',
    Subtotal: 'Subtotal',
    Shipping: 'Levering',
    Shape: 'Form',
    PickShape: 'Vælg en form at tilføje til lærredet',
    ShapeAdded: 'Form tilføjet. Klik på en anden for at erstatte den.',
    Clipart: 'Illustration',
    PickClipart: 'Vælg en illustration at tilføje til lærredet',
    ClipartAdded: 'Illustration tilføjet. Klik på en anden for at erstatte den.',
    SearchClipart: 'Søg en illustration…',
    NoClipartFound: 'Ingen illustration fundet',
    Cliparts: 'Clipart',
    Illustration: 'Illustration',
    AiImage: 'AI-billede',
    AiImageIntro: 'Beskriv, hvad du ønsker, vælg et format, og få 2 forslag.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Kvadratisk',
    AiFormatPortrait: 'Stående',
    AiFormatLandscape: 'Liggende',
    AiImagePlaceholder: 'F.eks.: en stiliseret rød ræv, flad stil, gennemsigtig baggrund…',
    AiGenerate: 'Generer',
    AiGenerating: 'Genererer…',
    AiPickResult: 'Vælg et forslag',
    AiImageAdded: 'Billede tilføjet til lærredet',
    AiImageError: 'Billedgenerering mislykkedes',
    AiNoResult: 'Intet billede genereret',
    AiImageNotInPlan: 'AI-billedgenerering er ikke inkluderet i dit abonnement. Aktivér funktionen for at bruge den.',
    SearchIllustration: 'Søg en illustration…',
    NoIllustrationFound: 'Ingen illustration fundet',
    IllustrationIntro: 'Søg efter vektorillustrationer at tilføje til lærredet.',
    IllustrationError: 'Søgning efter illustrationer mislykkedes',
    IllustrationNotVector: 'Dette resultat er ikke en brugbar vektor',
    Texts: 'Tekster',
    Images: 'Billeder',
    Colors: 'Farver',
    ThemeEditDesc: 'Rediger temaets tekster, billeder og farver.',
    ThemeNotFound: 'Tema ikke fundet.',
    ThemeNoEditable: 'Dette tema indeholder ingen redigerbare elementer.',
    Helpers: 'Linealer, hjælpelinjer og gitter',
    Rulers: 'Linealer',
    RulersHint: 'Skala i pixels',
    Guides: 'Hjælpelinjer',
    GuidesHint: 'Markeringer ved 25 / 50 / 75 %',
    GridHint: 'Gitter som overlay',
    Snapping: 'Fastgørelse',
    SnappingHint: 'Justerer efter midte / gitter / andre objekter',
    LeaveConfirm: 'Er du sikker på, at du vil miste dine ændringer?',
    Products: 'Produkter',
    Customization: 'Tilpasning',
    BackToCustomizationType: 'Tilpasningstype',
    SaveNoChanges: 'Ingen ændringer at gemme',
    ChooseCategory: 'Vælg en kategori',
    SelectProduct: 'Vælg et produkt',
    Loading: 'Indlæser',
    ProofLogoTooLarge: 'Logoet er for stort (maks. 500 KB).',
    ProofLogoInvalidType: 'Ikke-understøttet billedformat.',
    ProofLogoImported: 'Logo importeret.',
    ProofLogoImportFailed: 'Import af logo mislykkedes.',
    YouHaveProjects: 'Du har {count} igangværende projekt(er)',
    ResumeProject: 'Genoptag et projekt',
    ResumeProjectHint: 'Fortsæt, hvor du slap.',
    YourProjects: 'Dine igangværende projekter',
    OpenProject: 'Åbn dette projekt',
    NoProjects: 'Ingen igangværende projekter.',
    AppUpdating: 'Opdaterer applikationen…',
    DraftRestored: 'Kladde gendannet',
    SaveExpiredTitle: 'Gemt projekt udløbet',
    SaveExpiredMessage: 'Dette gemte projekt er udløbet eller ikke længere tilgængeligt.',
    Continue: 'Fortsæt',
    PhotoFramePickShape: 'Vælg en ramme',
    PhotoFramePlacePhoto: 'Placer og juster dit foto',
    PhotoFrameChangePhoto: 'Skift foto',
    PhotoFrameDropTitle: 'Slip et foto her',
    PhotoFrameDropSub: 'eller klik for at uploade',
    Rotation: 'Rotation',
    Reset: 'Nulstil',
    ProofLogoTitle: 'Logo på korrektur',
    ProofLogoUseSite: 'Behold {site}s logo',
    ProofLogoUseMine: 'Med mit eget logo',
    ProofLogoUseMineDesc: 'Kun på korrekturen, ikke på trykfilerne.',
    ProofLogoNone: 'Uden logo',
    ProofLogoDropTitle: 'Upload dit logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Validerer din ordre',
    LoadingStepScreenshots: 'Genererer forhåndsvisninger',
    LoadingStepPrintFile: 'Genererer trykfiler',
    LoadingStepUpload: 'Uploader til server',
    LoadingStepSave: 'Gemmer konfiguration',
    LoadingGraduation: 'Indlæser graduering',
    OptimizingImage: 'Optimerer billede',
    LoadingScene: 'Indlæser scene',
    LoadingStepZip: 'Opretter zip',
    LoadingProduct: 'Indlæser produkt',
    Category: 'Kategori',
    Product: 'Produkt',
    Summary: 'Oversigt',
    Zone: 'Zone',
    SelectZone: 'Vælg en zone',
    SelectAZone: 'Vælg en zone',
    Undo: 'Fortryd',
    Redo: 'Gentag',
    Recenter: 'Centrér visningen',
    HelpersIntro: 'Zonekanter, gitter, linealer og hjælpelinjer på 2D-lærredet.',
    ShowZoneBordersHint: 'Zonerammer på hovedlærredet',
    Save: 'Gem',
    Saving: 'Gemmer',
    Grid: 'Gitter',
    SwitchTo3D: 'Skift til 3D',
    PrintZone: 'Trykzone',
    ViewModeSwitch: 'Visningstilstand',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Dobbelt',
    ShowZoneBorders: 'Vis zonernes kant',
    ShowZoneBordersHelp: 'Viser/skjuler den stiplede kant og zonernes etiket på 2D-lærredet.',
    ManageElements: 'Administrer elementer',
    StartWithTheme: 'Start med et tema',
    Customize: 'Tilpas',
    FromThemeLibrary: 'Fra vores temabibliotek',
    StartFromScratch: 'Start fra bunden',
    Or: 'eller',
    PreviousCreations: 'Tidligere kreationer',
    WithModel: 'Med en skabelon',
    Search: 'Søg',
    SubCategory: 'Underkategori',
    Next: 'Næste',
    Previous: 'Forrige',
    Validate: 'Bekræft',
    DownloadMyProject: 'Download mit projekt',
    EditThemeColors: 'Rediger elementernes farver',
    AddPattern: 'Tilføj en baggrund',
    EditGraduation: 'Rediger graduering',
    Pattern: 'Baggrund',
    PatternHint: 'Mønsteret gentages over hele personaliseringsområdet. Farverne kan tilpasses.',
    SearchTheme: 'Søg et tema (titel eller tag)',
    Theme: 'Tema',
    Graduation: 'Graduering',
    Graduation_s: 'Graduering(er)',
    ErrorOccurred: 'Der opstod en fejl.',
    ReloadPage: 'Genindlæs siden.',
    LoadingCategories: 'Indlæser kategorier',
    ShowAll: 'Vis alle',
    Categories: 'Kategorier',
    ComingSoon: 'Kommer snart',
    DropImageHere: 'Træk et billede hertil',
    ReleaseToImport: 'Slip for at importere',
    OrClickToBrowse: 'eller klik for at gennemse',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Denne trykmetode arbejder med faste farver. Vi anbefaler vektorfiler for et optimalt resultat.',
    SearchInPhotoGallery: 'Søg i vores fotogalleri',
    QrCode: 'QR-kode',
    QrCodeContent: 'Indhold (URL, tekst, e-mail…)',
    QrCodePlaceholder: 'https://eksempel.com',
    QrCodeForeground: 'QR-farve',
    QrCodeBackground: 'Baggrund',
    QrCodeTransparentBg: 'Gennemsigtig baggrund',
    QrCodeErrorLevel: 'Fejltolerance',
    QrCodeErrorL: '7 % (lav tæthed)',
    QrCodeErrorM: '15 % (standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (høj)',
    QrCodeEmptyPreview: 'Indtast indhold for at få vist eksempel',
    QrCodeRequired: 'QR-kodens indhold er obligatorisk.',
    QrCodeInvalidUrl: 'Indtast en gyldig QR-kode-URL (http:// eller https://).',
    QrCodeAdd: 'Tilføj QR-kode',
    QrCodeEditOnlyColors:
        'Efter oprettelse af en QR-kode kan kun farverne ændres. For at ændre indholdet skal du slette den og oprette en ny.',
    ImageQualityGood: 'God opløsning',
    ImageQualityMedium: 'Mellem opløsning',
    ImageQualityLow: 'Lav opløsning – forstør billedet eller gør det mindre på lærredet',
    LowQualityAlertTitle: 'Bemærk',
    LowQualityAlertMessage:
        'Din kreation indeholder billeder af lav kvalitet eller billeder, der er forstørret for meget i forhold til deres oprindelige opløsning. Ret din kreation, eller accepter risikoen for pixelering ved tryk.',
    LowQualityAlertHint: 'Grænse for lav opløsning:',
    LowQualityAcceptRisk: 'Jeg accepterer risikoen for pixelering af mine billeder af lav kvalitet',
    Preview: 'Eksempel',
    Bold: 'Fed',
    Italic: 'Kursiv',
    Underline: 'Understreget',
    FontSize: 'Størrelse',
    SelectFont: 'Vælg en skrifttype',
    UploadFont: 'Upload min skrifttype',
    UploadFontHint: 'TTF eller OTF · maks. 5 MB',
    CustomFontBadge: 'egen',
    CustomFontImported: 'Skrifttype importeret.',
    CustomFontFormatError: 'Ikke-understøttet format (kun TTF eller OTF).',
    CustomFontTooLarge: 'Skrifttype for stor (maks. 5 MB).',
    CustomFontImportFailed: 'Import af skrifttype mislykkedes.',
    CustomFontRemoved: 'Skrifttype fjernet.',
    RecentFonts: 'Seneste',
    Clear: 'Ryd',
    TextColor: 'Tekstfarve',
    TextOutline: 'Kontur',
    AddOutline: 'Tilføj en kontur',
    RemoveOutline: 'Fjern kontur',
    PickColor: 'Vælg en farve',
    PickThemeCategory: 'Vælg en kategori for at udforske temaer',
    NoThemeInCategory: 'Intet tema i denne kategori',
    ThemePreviewLabel: 'Temaeksempel',
    PickAnotherTheme: 'Vælg et andet tema',
    Keep: 'Behold',
    LoadingThemes: 'Indlæser temaer',
    LoadingPatterns: 'Indlæser baggrunde',
    EditableThemeColors: 'Redigerbare farver på elementerne',
    PickAColor: 'Vælg en farve',
    SelectALayout: 'Vælg en skabelon',
    CreateLayer: 'Opret et element',
    LastDownloads: 'Seneste downloads',
    Cancel: 'Annuller',
    Back: 'Tilbage',
    BackToProvider: 'Tilbage til {provider}',
    LayerNotFound: 'Elementet blev ikke fundet',
    ChangeImage: 'Skift billede',
    ChangePattern: 'Skift baggrund',
    Resize: 'Tilpas størrelse',
    RemoveBackground: 'Fjern baggrund',
    Processing: 'Behandler…',
    AddFilter: 'Tilføj et filter',
    PhotoCredit: 'Foto af {author} på {provider}',
    PhotoBy: 'Foto af',
    On: 'på',
    LinkRedirectionWarning: 'Dette link omdirigerer dig til dette websted',
    LoadMore: 'Indlæs mere',
    EditLayer: 'Rediger element',
    Import: 'Importer',
    FromYourDevice: 'Fra din enhed',
    FromImageGallery: 'Fra billedgalleriet',
    NoGraduationsAvailable: 'Ingen graduering tilgængelig',
    Confirm: 'Bekræft',
    CustomizeProduct: 'Tilpas dit produkt',
    WriteYourText: 'Skriv din tekst her',
    Text: 'Tekst',
    Image: 'Billede',
    DesignSummary: 'Oversigt over dit design',
    AddOptions: 'Tilføj muligheder',
    TermsOfSale: 'Almindelige salgsbetingelser',
    TOSMessage:
        'Jeg bekræfter, at min kreation overholder [Almindelige salgsbetingelser](#) og især artikel 8 - Intellektuel ejendomsret',
    IValidateMyCreation: 'Jeg bekræfter min kreation',
    FunctionalityNotAvailable: 'Funktion ikke tilgængelig',
    Lock: 'Lås',
    Unlock: 'Lås op',
    AddLayer: 'Tilføj et element',
    LayerSectionTemplates: 'Skabeloner',
    LayerSectionText: 'Tekst og data',
    LayerSectionImages: 'Billeder',
    LayerSectionDecor: 'Dekoration',
    LayerSectionTools: 'Værktøjer',
    DragLayersToReorder: 'Træk lagene for at omorganisere dem',
    PleaseAgreeTOS: 'Accepter de almindelige betingelser for at bekræfte din kreation.',
    ErrorExportPrintFile: 'Der opstod en fejl under eksport af trykfilen.',
    ErrorExportProofFile: 'Der opstod en fejl under eksport af korrekturen.',
    ErrorAddToCart: 'Der opstod en fejl under tilføjelse til kurven: ',
    Gabarit: 'Skabelon',
    FicheTechnique: 'Datablad',
    GeneratingPrintFile: 'Genererer trykfil…',
    GeneratingProofFile: 'Genererer korrektur…',
    LeaveCustomizer: 'Forlad konfiguratoren',
    LeaveManager: 'Forlad elementstyring',
    ChangeProductTitle: 'Din kreation vil blive slettet.',
    ChangeProductConfirm: 'Skift af produkt sletter din kreation permanent, er du sikker?',
    Duplicate: 'Dupliker',
    LoadingTheme: 'Indlæser tema',
    LoadingPattern: 'Indlæser baggrund',
    Expand: 'Forstør',
    Shrink: 'Formindsk',
    TiltLeft: 'Vip til venstre',
    TiltRight: 'Vip til højre',
    Rotate: 'Roter',
    Move: 'Flyt',
    Reposition: 'Flyt igen',
    MoveUp: 'Flyt op',
    MoveDown: 'Flyt ned',
    MoveLeft: 'Flyt til venstre',
    MoveRight: 'Flyt til højre',
    NoCustomization: 'Der er ingen tilpasning på produktet.',
    MissingCustomization: 'Manglende tilpasning',
    SelectGraduation: 'Vælg en graduering',
    ProofTitle: 'Korrektur',
    ProofDesignTitle: '2D-tilpasning',
    ProofScreenshotsTitle: '3D-visninger',
    ProofSelectedInksTitle: 'Valgte farver',
    Warning: 'Bemærk',
    SelectZoneBeforeTheme: 'Vælg en zone, før du vælger et tema.',
    ThemeTooManyElements: 'Temaet indeholder for mange elementer. Vælg et andet',
    Error: 'Fejl',
    ProductNotFound: 'Produkt ikke fundet',
    ProductNotFoundMessage: 'Produkt ikke fundet, du bliver omdirigeret til forsiden.',
    NoCategoryAvailable: 'Ingen kategori tilgængelig',
    CategoryNotFound: 'Kategori ikke fundet',
    CategoryNotFoundMessage: 'Kategori ikke fundet, du bliver omdirigeret til forsiden.',
    Unavailable: 'Ikke tilgængelig',
    SavedConfigurations: 'Gemte konfigurationer',
    YourSavedConfigurations: 'Dine gemte konfigurationer',
    NoSavedConfigurations: 'Ingen gemt konfiguration for dette produkt',
    ConfigurationName: 'Konfigurationens navn',
    Created: 'Oprettet',
    Expires: 'Udløber',
    Load: 'Indlæs',
    ConfirmDeleteConfiguration: 'Er du sikker på, at du vil slette denne konfiguration?',
    Close: 'Luk',
    Step: 'Trin',
    CustomizeProductDesc: 'Vælg, hvordan du vil starte: fri kreation eller ud fra et tema foreslået nedenfor.',
    StartFromScratchDesc: 'Et blankt lærred til at tilføje tekster, billeder og former, uden fast skabelon.',
    ChooseProductDesc: 'Vælg et produkt at tilpasse.',
    PrintMethod: 'Trykmetode',
    ChoosePrintMethod: 'Vælg din metode',
    ChoosePrintMethodDesc: 'Vælg trykmetoden for dette produkt. Dette valg er endeligt for denne tilpasning.',
    Digital: 'Digital',
    ScreenPrinting: 'Serigrafi',
    LaserEngraving: 'Lasergravering',
    Embroidery: 'Broderi',
    RestrictedToPalette: 'Farver begrænset til paletten',
    ChooseInks: 'Vælg dine farver',
    ChooseThreads: 'Vælg dine tråde',
    AppliesToZone: 'Zone: {zone}',
    Ink: 'Farve',
    Thread: 'Tråd',
    InkOverride: 'Gennemtving en farve',
    ThreadOverride: 'Gennemtving en tråd',
    SuggestInks: 'Foreslåede farver',
    SuggestThreads: 'Foreslåede tråde',
    RecommendColorsFromImage: 'Anbefal farver ud fra billedet',
    NoColorSuggestion: 'Intet farveforslag til dette billede.',
    InkAssistantHelp: 'Denne metode bruger en palet med {count} faste farver.',
    InkAssistantQuestion: 'Hvordan vil du definere dine farver?',
    InkAssistantUpload: 'Hjælp mig med at finde mine farver',
    InkAssistantUploadDesc:
        'Importer dit billede, logo eller motiv – vi registrerer automatisk de nærmeste paletfarver.',
    InkAssistantManual: 'Jeg vælger mine farver manuelt',
    InkAssistantManualDesc: 'Vælg hver farve, én ad gangen, i paletten.',
    InkAssistantAnalyzing: 'Analyserer dit billede…',
    InkChoiceModifiableHint: 'Dette valg kan ændres når som helst.',
    InkAssistantResultDesc: 'Her er de paletfarver, der ligger tættest på dit billede.',
    InkDuplicateWarning:
        'Denne farve er allerede valgt til en anden farve / tråd. Vælger du den anden gang, sammenlægges farverne permanent. Er du sikker?',
    Selected: 'Valgt',
    VectorizeImage: 'Vektoriser billedet',
    Vectorizing: 'Vektoriserer…',
    VectorizePreviewTitle: 'Resultat af vektoriseringen',
    VectorizeIntro:
        'Billedet konverteres til en vektor og begrænses til de valgte farver. Bekræft resultatet for at anvende det.',
    VectorizeApply: 'Anvend vektor',
    VectorizeConsent:
        'Jeg forstår, at jeg er ansvarlig for at kontrollere vektoriseringsresultatet, og at trykket vil afspejle det.',
    VectorizeThreshold: 'Tærskel (detalje / baggrund)',
    VectorizeThresholdHint:
        'Juster tærsklen for at finjustere: lavere fjerner mere lys baggrund (stregtegning); højere bevarer flere lyse zoner.',
    VectorizeCancel: 'Annuller',
    VectorizeFailed: 'Vektoriseringen mislykkedes. Prøv igen, eller vælg et andet billede.',
    Before: 'Før',
    After: 'Efter',
    VariableText: 'Variabel tekst',
    VariableTextIntro:
        'Denne funktion minder om en masseudsendelse og giver dig dit produkt trykt i ét unikt eksemplar pr. tekst; antallet beregnes automatisk til din kurv.',
    VariableTextData: 'Data (én linje = ét eksemplar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importer en CSV / Excel',
    SessionImages: 'Importerede billeder',
    Accept: 'Accepter',
    UploadConsentMessage:
        'Jeg bekræfter, at ingen af mine filer overtræder gældende love, ophavsret eller tredjeparters rettigheder.',
    VariableTextNoData: 'Tilføj mindst én linje for at få vist eksempel.',
    VdpFields: 'Variable felter',
    VdpFieldName: 'Feltnavn',
    VdpPlace: 'Placer',
    VdpPlaced: 'Placeret',
    VdpAddField: 'Tilføj et felt',
    VdpAddRow: 'Tilføj en linje',
    VdpLine: 'Række',
    VdpEnterData: 'Indtast mine data',
    Done: 'Færdig',
    VdpFieldStyle: 'Feltstil',
    VdpFirstRowHeader: '1. linje = overskrift (feltnavne)',
    VdpQuantity: 'Antal: {qty}',
    VdpQuantityHint: 'Antallet bestemmes af antallet af linjer i din variable tekst.',
    VariableTextOnlyOne: 'Kun ét felt til variabel tekst pr. kreation.',
    VariableTextEmptyFile: 'Tom fil eller uden brugbar kolonne.',
    VariableTextImportError: 'Denne fil kan ikke læses. Brug en CSV, eller indsæt teksten.',
    VariableTextExcelUnavailable: 'Excel-læsning ikke tilgængelig. Eksporter til CSV, eller indsæt teksten.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Valgte farver: {chosen}/{required}. Vælg alle farver, før du bekræfter.',
    PreflightScreenColorCount: 'Serigrafi: din kreation er begrænset til {count} farve(r).',
    PreflightMinStroke: 'Anbefalet minimum stregtykkelse: {mm} mm. Tyndere streger kan trykke dårligt.',
    PreflightMinFont: 'Anbefalet minimum skriftstørrelse: {pt} pt.',
    PreflightLaserMonochrome: 'Lasergravering: det endelige resultat er monokromt.',
    More: 'Flere',
    All: 'Alle',
    AllCategories: 'Alle kategorier',
    SearchCategory: 'Søg en kategori…',
    NoProductAvailable: 'Ingen produkter i denne kategori.',
    ChooseProductTitle: 'Vælg dit produkt at tilpasse',
    PrintMethodQuestion: 'Hvordan vil du trykke dit {product}?',
    PrintMethodIntro:
        'Hver metode har sine styrker og begrænsninger — den bestemmer de farver og finish, der er tilgængelige bagefter.',
    StartLabel: 'Udgangspunkt',
    StartTitle: 'Start fra et tema eller en blank side',
    StartIntro: 'Et tema = et færdigt design til at tilpasse (hurtigst). Blank side = fuld kontrol.',
    StepProduct: 'Produkt',
    StepMethod: 'Metode',
    StepStart: 'Start',
    StepDesign: 'Design',
    ChangeTheme: 'Skift tema',
    BackToTheme: 'Tilbage til tema',
    Recent: 'Seneste',
    WhiteNotPrintable: 'Hvid kan ikke trykkes (gennemsigtig).',
    LoginToSave: 'Log ind for at finde dine designs på din konto.',
    Login: 'Log ind',
    LoggingIn: 'Logger ind…',
    ContinueWithoutAccount: 'Fortsæt uden konto',
    SaveEmailPlaceholder: 'Din e-mailadresse',
    SaveEmailHint: 'Du får et link til at genoptage dit projekt (gemmes i 30 dage).',
    SaveConfirmTitle: 'Projekt gemt',
    SaveConfirmMessage: 'Dit projekt er gemt. Vi har netop sendt dig en e-mail med linket til at genoptage det.',
    DisableEmbroideryEffect: 'Deaktiver broderieffekt',
    AddThread: 'Tilføj en tråd',
    RemoveThread: 'Fjern en tråd',
    VectorizeDenoise: 'Reducer støj',
    VectorizeDenoiseHint: 'Fjerner pletter og små uønskede prikker.',
    VectorizeSmoothing: 'Udjævning',
    VectorizeSmoothingHint: 'Afrunder konturerne (færre hjørner).',
    ZoomIn: 'Zoom ind',
    ZoomOut: 'Zoom ud',
    Fit: 'Tilpas',
    Apply: 'Anvend',
    Edit: 'Rediger',
    Support: 'Support',
    VectorizeAcknowledge:
        'Jeg forstår, at jeg er ansvarlig for at kontrollere resultatet af vektoriseringen, og at trykket vil afspejle det.',
    Crop: 'Beskær',
    Font: 'Skrifttype',
    Style: 'Stil',
    Outline: 'Kontur',
    Steps: 'Trin',
    Tools: 'Værktøjer',
    ThemeColors: 'Farver',
    Minimize: 'Minimer',
    MoveLayerUp: 'Flyt lag op',
    MoveLayerDown: 'Flyt lag ned',
    DragLayer: 'Træk for at omarrangere',
    NoResult: 'Intet resultat',
    SearchElement: 'Søg efter et element…',
    ExpertMode: 'Eksperttilstand',
    Finish: 'Afslut',
    ChooseImageOrPhoto: 'Vælg et billede eller foto',
    WizardIntro: 'Følg trinnene for et personligt design på 1 minut.',
    WizardIntroExpert: 'Vil du have mere frihed? Skift til eksperttilstand.',
    ClickToChooseImage: 'Klik her for at vælge et billede eller foto',
    ChooseCategoryDesc: 'Vælg en produktfamilie for at starte.',
    SelectProductDesc: 'Vælg et produkt for at starte…',
    FinalReview: 'Sidste trin',
    StartWithThemeDesc: 'Start ud fra et forudindstillet design.',
    WithModelDesc: 'Vælg en færdig skabelon.',
    ExpertModeConfirmTitle: 'Eksperttilstand',
    ExpertModeConfirmMsg:
        'At skifte til eksperttilstand er et endeligt valg. Denne tilstand er lidt mere kompleks at bruge, men giver dig mulighed for at tilføje og redigere elementer uden begrænsninger.',
    ExpertModeHint: 'Fuldfør dit design uden begrænsninger – tilføj tekst og billeder, som du vil.',
    VariableData: 'Variable data',
    PhotoFrame: 'Fotoramme',
    PhotoFrameHint: 'Vælg en form, og læg derefter et foto ind i den.',
    PhotoFrameChooseShape: '1. Rammens form',
    PhotoFrameChangeShape: 'Skift form',
    PhotoFramePickPhoto: 'Vælg et foto',
    FromLibrary: 'Fra biblioteket',
    VdpMaxRowsReached: 'Maksimalt lager nået',
    VdpImportTruncated: 'Import begrænset til tilgængeligt lager',
    LetterSpacing: 'Bogstavafstand',
    OutlineActive: 'Kontur aktiveret',
    OutlineThickness: 'Konturtykkelse',
    AlignLeft: 'Venstrejuster',
    AlignCenter: 'Centrér',
    AlignRight: 'Højrejuster',
    Uppercase: 'Store bogstaver',
    TextFormatting: 'Formatering',
    FontSizeLabel: 'Skriftstørrelse',
    SelectionActions: 'Handlinger for markering',
    DragToMove: 'Træk for at flytte',
    DragToResize: 'Træk for at ændre størrelse',
    DragToRotate: 'Træk for at rotere',
    MoveUpOneLevel: 'Flyt et niveau op',
    MoveDownOneLevel: 'Flyt et niveau ned',
    BringToFront: 'Placér forrest',
    Front: 'Forgrund',
    SendToBack: 'Placér bagerst',
    BackgroundNeverUnderPattern: 'Baggrund (aldrig under et baggrundsmønster)',
    EyedropperColor: 'Farvepipette',
    PresetColors: 'Foruddefinerede farver',
    RecentColors: 'Seneste farver',
    Palette: 'Palet',
    HexValue: 'Hex-værdi',
    AiResultsHint: 'Find alle forslag under fanen Billede',
    Notifications: 'Notifikationer',
    Zoom: 'Zoom',
    GuidedCustomization: 'Guidet tilpasning',
    Actions: 'Handlinger',
    InkAssistantYourChoice: 'Du har valgt:',
    InkAssistantCorrectQuestion: 'Vil du ændre dette valg?',
    '': ''
};
